import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/logo-short-colored.svg")